export enum SvcCustomFieldsRegistrationFeature {
  lpp = 'FDD86353-E87C-40CB-9B30-F75CC60FF202',
  unsafeCondition = '2B87A9D8-2336-43FB-A44E-1961262BEFD6',
  rca = 'ABA1CD5B-96EF-4BA0-AFC0-066D2EC6CEB4',
  alert = 'E34F25D0-9E7C-4CD7-A763-9CDD83F27C29',
  actionPlan = 'FEE05433-8B2D-4220-B086-C7D4EF0EC0FA',
  defectTag = 'DA019383-33B3-4152-B0B7-74F5FDD8BBC9',
  cil = 'C022E938-A1C8-4D7B-87DE-7D10B2514DF4',
}
